/**
 * Upgrade Funnel Constants - v2
 * 
 * Pricing tiers, benefits, and sync limits for NinjaCash Pro.
 * 
 * v2 Changes (2026-01-17):
 * - Removed yearly tier (only 5% chose it vs 10% lifetime)
 * - Lowered lifetime $79 -> $49 (10 months payback, not 16)
 * - Added trial config to monthly
 * - Outcome-focused benefits copy
 * 
 * See: FUNNEL_V2_PLAN.md
 */

export const MAX_SYNC_SIZE_BYTES = 20 * 1024 * 1024; // 20MB hard cap

// i18n (F5 Phase 3): all user-facing text fields hold CATALOG KEYS
// (funnel.* in src/i18n/catalogs) resolved with t() at render sites.
// Machine fields (id, price, cycle, trialDays, counts) never change.

// v2 Pricing: Monthly (with trial) + Lifetime only
export const PRICING = {
  monthly: {
    id: 'monthly',
    price: 4.99,
    label: 'funnel.monthly_label',
    cycle: 'monthly',
    trialDays: 3,
    ctaText: 'funnel.monthly_cta',
    badge: 'funnel.monthly_badge',
    noPaymentToday: true,
  },
  lifetime: {
    id: 'lifetime',
    price: 49,  // was 79
    label: '$49',
    cycle: 'one-time',
    ctaText: 'funnel.lifetime_cta',
    badge: 'funnel.lifetime_badge',
    remaining: 47,
    total: 100,
  },
} as const;

export type PricingPlan = keyof typeof PRICING;

// v2 Benefits: Outcome-focused copy (not feature-focused)
export const BENEFITS = [
  {
    id: 'no-reentry',
    icon: 'sync',
    text: 'funnel.benefit1_text',
    detail: 'funnel.benefit1_detail',
  },
  {
    id: 'no-loss',
    icon: 'shield',
    text: 'funnel.benefit2_text',
    detail: 'funnel.benefit2_detail',
  },
  {
    id: 'everywhere',
    icon: 'cloud',
    text: 'funnel.benefit3_text',
    detail: 'funnel.benefit3_detail',
  },
  {
    id: 'private',
    icon: 'lock',
    text: 'funnel.benefit4_text',
    detail: 'funnel.benefit4_detail',
  },
] as const;

export type BenefitIcon = typeof BENEFITS[number]['icon'];

export const FAQ_ITEMS = [
  { question: 'funnel.faq1_q', answer: 'funnel.faq1_a' },
  { question: 'funnel.faq2_q', answer: 'funnel.faq2_a' },
  { question: 'funnel.faq3_q', answer: 'funnel.faq3_a' },
  { question: 'funnel.faq4_q', answer: 'funnel.faq4_a' },
  { question: 'funnel.faq5_q', answer: 'funnel.faq5_a' },
  { question: 'funnel.faq6_q', answer: 'funnel.faq6_a' },
] as const;

// Trust signals for web platform
export const TRUST_SIGNALS = {
  noPaymentToday: 'funnel.trust_no_payment',
  cancelAnytime: 'funnel.trust_cancel',
  securePayment: 'funnel.trust_secure',
} as const;
